import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import {
  Approval,
  ApprovalAction,
} from '../../Interfaces/admin/ApprovalSequence.interface';
import { formatDateTime } from '@/src/utils/formatUtils';
import { createArray } from '@/src/utils/utils';

type ApprovalHistoryProps = {
  show: boolean;
  hide: () => void;
  approvals: Approval[];
  lastStep: number;
};

const ApprovalHistory = ({
  show,
  hide,
  approvals,
  lastStep,
}: ApprovalHistoryProps) => {
  const noSequence = !lastStep && !approvals.length;
  const sortedApprovals = approvals.sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );
  const pendingSteps = createArray(
    sortedApprovals.reduce((acc, approval) => {
      if (approval.action === ApprovalAction.reject) {
        acc = acc === 0 ? 0 : acc - 1;
      } else {
        acc += 1;
      }

      return acc;
    }, 0),
    lastStep ?? 0
  );

  return (
    <Dialog
      header="Draft Approval History"
      visible={show}
      onHide={() => {
        hide();
      }}
      className="w-fit"
      contentClassName="flex justify-content-center"
    >
      <div className="flex flex-column gap-3 blackText w-full">
        {sortedApprovals.map((approval) => (
          <div
            key={approval.id}
            className="flex gap-2 align-items-center text-18px "
          >
            <Checkbox
              checked={true}
              disabled={true}
              className={`${
                approval.action === ApprovalAction.approve
                  ? 'checkbox-green'
                  : 'checkbox-red'
              }`}
            />
            <span className="font-medium">
              {approval.action === ApprovalAction.approve
                ? 'Approval'
                : 'Rejection'}{' '}
              {approval.step}:
            </span>
            {approval.user.userName} - {formatDateTime(approval.createdAt)}
          </div>
        ))}
        {pendingSteps.map((value) => (
          <div key={value} className="flex gap-2 align-items-center text-18px">
            <Checkbox checked={false} disabled={true} />
            <span className="font-medium">Approval {value}:</span>
            Pending
          </div>
        ))}
        {noSequence && (
          <div className="text-18px">No approval sequence was found!</div>
        )}
      </div>
    </Dialog>
  );
};

export default ApprovalHistory;
